
export const getAddress = (address) => {
  let addressString = '';
  if (address) {
    if (address.street) {
      addressString = `${addressString} ${address.street}`;
    }
    if (address.city) {
      addressString = `${addressString} ${address.city}`;
    }
    if (address.country) {
      addressString = `${addressString} ${address.country}`;
    }
    if (address.pinCode) {
      addressString = `${addressString} - ${address.pinCode}`;
    }
  }
  return addressString;
};

export const getLocation = (address) => {
  let addressString = '';
  if (address) {
    if (address.name) {
      addressString = `${addressString} ${address.name},`;
    }
    if (address.street) {
      addressString = `${addressString} ${address.street},`;
    }
    if (address.city) {
      addressString = `${addressString} ${address.city},`;
    }
    if (address.country) {
      addressString = `${addressString} ${address.country}`;
    }
    if (address.pinCode) {
      addressString = `${addressString} - ${address.pinCode}`;
    }
  }
  return addressString;
};

export const getDistanceRem = (distRem) => {
  let result = '-';
  if (distRem) {
    result = (distRem === 'NA') ? distRem : `${distRem} KM`;
  }
  return result;
};
